import { EditOutlined } from "@ant-design/icons";
import Button, { ButtonProps } from "../button";

export function EditButton(props: ButtonProps) {
  return <Button icon={<EditOutlined />} accent {...props} />;
}
